$bog_feedback2_form $mol_page
	Head null
	feedback_id \
	registry_link \
	title @ \Feedback ( one per user )
	prompt_title @ \**Tell us what you think:**
	prompt_like @ \- What did you **like**?
	prompt_better @ \- What could be done **better**?
	prompt_future @ \- Any **suggestions** for the future?
	submit_send @ \Send feedback
	submit_update @ \Update feedback
	anonymous @ \Anonymous
	reply_send @ \Send reply
	reply_update @ \Update reply
	reply_open @ \Reply
	reply_cancel @ \Cancel
	reply_edit @ \Edit reply
	not_ready @ \Feedback storage is not ready yet, try again
	tools /
		<= Close null
	body /
		<= Prompt $mol_text
			text <= prompt \
		<= Entry_my $mol_textarea
			hint @ \Your feedback
			value? <=> draft_text? \
		<= Contact_field $mol_string
			hint @ \Contact (optional)
			value? <=> draft_contact? \
		<= Submit $mol_button_major
			title <= submit_title \
			click? <=> submit? null
		<= Entries $mol_section
			title @ \All feedback
			content <= entry_rows /
				<= Entry_row*0 $mol_section
					title <= entry_row_contact* \
					content /
						<= Entry_row_text* $mol_text
							text <= entry_row_text* \
						<= Entry_row_reply_wrap* $mol_view
							sub <= entry_row_reply_sub* /
								<= Entry_row_reply_display* $mol_view
									sub /
										<= Entry_row_reply_header* $mol_paragraph
											title <= entry_row_reply_header_text* @ \Reply from admin
										<= Entry_row_reply_text* $mol_text
											text <= entry_row_reply_text* \
								<= Entry_row_reply_form* $mol_view
									sub /
										<= Entry_row_reply_input* $mol_textarea
											hint @ \Write a reply...
											value? <=> entry_row_reply_draft*? \
										<= Entry_row_reply_submit* $mol_button_major
											title <= entry_row_reply_submit_title* \
											click? <=> entry_row_reply_submit*? null
								<= Entry_row_reply_toggle* $mol_button_minor
									title <= entry_row_reply_toggle_title* \
									click? <=> entry_row_reply_toggle*? null
	Not_configured $mol_status
		message @ \Form not yet configured
